import { request_list, create_detail, update_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
import Crud from './crud'
import Vue from 'vue';
var crud = new Crud('zns-msg', 'tin nhắn ZNS');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Status: 0
    },
    templates: [],
    campaigns: []
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    get_zns_template({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('zns-msg/template', ret => {
            commit('set_zns_template', ret);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_campaigns({ commit }) {
        commit("setLoading", { loading: true });
        request_list('zns-msg/campaign', ret => {
            commit('set_campaigns', ret);
            commit("setLoading", { loading: false });
        }, Vue.http, null, this.state.authentication.token);
    },
    update_campaign_status({ commit }, { id, status }) {
        return new Promise(resolve => {
            commit("setLoading", { loading: true });
            update_detail('zns-msg/campaign', res => {
                sendSuccessNotice('Cập nhật chiến dịch ZNS thành công.');
                commit("setLoading", { loading: false });
                resolve(res);
            }, Vue.http, { status }, id, this.state.authentication.token);
        });
    },
    send_zns({ commit }, data) {
        return new Promise(resolve => {
            commit("setLoading", { loading: true });
            create_detail('zns-msg/template', res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể tạo chiến dịch ZNS.')
                }
                else {
                    sendSuccessNotice('Tạo chiến dịch ZNS thành công.')
                    resolve(res);
                }
                commit("setLoading", { loading: false });
            }, Vue.http, data, this.state.authentication.token);
        });
    },
};
const mutations = {
    ...crud.mutations,
    set_zns_template(state, ret) {
        state.templates = ret.data;
    },
    set_campaigns(state, ret) {
        state.campaigns = ret.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
